<template>
    <modal id="hotel-special-cleaning-modal"
        size="large"
        v-model="showModal"
        :title="generateModalTitle('special_cleaning')"
        @submit="submitData" :loading="loading"
        :preloader="preloader">

        <form
            ref="form"
            :data-url="selectedUrl ? selectedUrl : `${TENANT_BASE_URL}app/hotel/special-cleaning`"
            @submit.prevent="submitData"
        >
            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('hotel')"
                        list-value-field="name"
                        v-model="formData.hotel_id"
                        :required="true"
                        :chooseLabel="$t('hotel')"
                        :error-message="$errorMessage(errors, 'hotel_id')"
                        :fetch-url="`${TENANT_BASE_URL}selectable/hotel/list`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="search-select"
                        :label="$t('room')"
                        list-value-field="name"
                        v-model="formData.room_id"
                        :chooseLabel="$t('room')"
                        :error-message="$errorMessage(errors, 'room_id')"
                        :fetch-url="room_url"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="search-select"
                        :label="$t('option')"
                        list-value-field="name"
                        v-model="formData.option_id"
                        :chooseLabel="$t('option')"
                        :error-message="$errorMessage(errors, 'option_id')"
                        :fetch-url="option_url"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="search-select"
                        :label="$t('check_by')"
                        list-value-field="employee_name"
                        v-model="formData.check_by"
                        :chooseLabel="$t('check_by')"
                        :error-message="$errorMessage(errors, 'check_by')"
                        :fetch-url="member_url"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('cleaning_date')"
                        v-model="formData.cleaning_date"
                        :placeholder="formData.cleaning_date ? $placeholder('date') : this.$t('not_added_yet')"
                        :error-message="$errorMessage(errors, 'cleaning_date')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('check_at')"
                        v-model="formData.check_at"
                        :placeholder="formData.check_at ? $placeholder('date') : this.$t('not_added_yet')"
                        :error-message="$errorMessage(errors, 'check_at')"
                    />
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {formDataAssigner} from "../../../../../common/Helper/Support/FormHelper";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {formatDateForServer} from "../../../../../common/Helper/Support/DateTimeHelper";

export default {
    name  : "HotelSpecialCleaningCreateModal",
    mixins: [FormHelperMixins, ModalMixin],
    data() {
        return {
            TENANT_BASE_URL,
            room_url  : null,
            option_url: null,
            member_url: null,
            formData  : {},
        }
    },
    watch  : {
        'formData.hotel_id': {
            handler  : function (hotel_id) {
                this.room_url   = `${TENANT_BASE_URL}selectable/hotel/room?hotel_id=${hotel_id || 0}`
                this.member_url = `${TENANT_BASE_URL}selectable/hotel/member?field_id=employee_id&hotel_id=${hotel_id || 0}`
                this.option_url = `${TENANT_BASE_URL}selectable/hotel/option?hotel_id=${hotel_id || 0}&type=2`
            },
            immediate: true
        }
    },
    methods: {
        submitData() {
            this.loading                = true
            this.formData.cleaning_date = this.formData.cleaning_date ? formatDateForServer(this.formData.cleaning_date) : '';
            this.formData.check_at      = this.formData.check_at ? formatDateForServer(this.formData.check_at) : '';

            let url      = this.$refs.form.dataset["url"];
            let formData = formDataAssigner(new FormData, this.formData);

            if (this.selectedUrl) {
                // for file update need to send by post.
                formData.append('_method', 'PATCH');
            }

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#hotel-special-cleaning-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'hotel-special-cleaning-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.formData  = response.data;
        },
    },
}
</script>